document.addEventListener('DOMContentLoaded', function () {
	//modal
	let scrollPosition = 0;

	// スクロール固定
	function lockScroll() {
		scrollPosition = window.pageYOffset;
		document.body.style.position = 'fixed';
		document.body.style.top = `-${scrollPosition}px`;
		document.body.style.width = '100%';
		console.log(scrollPosition);
	}

	// スクロール復元
	function unlockScroll() {
		// scrollBehaviorのスクロールを無効に
		const originalScrollBehavior = document.documentElement.style.scrollBehavior;
		document.documentElement.style.scrollBehavior = 'auto';

		document.body.style.position = '';
		document.body.style.top = '';
		document.body.style.width = '';
		window.scrollTo(0, scrollPosition);

		// scrollBehaviorのスクロールをもとに戻す
		setTimeout(() => {
			document.documentElement.style.scrollBehavior = originalScrollBehavior;
		}, 10);
	}

	const closeBtn = document.querySelector('.modal-close');

	// --- 動画用モーダルの追加部分 ---
	const movieModal = document.getElementById('modalMovie');
	const movieContent = movieModal.querySelector('.modal-content');
	const movieCloseBtn = movieModal.querySelector('.modal-close');

	// 複数ボタン video対応
	document.querySelectorAll('.js-modal-movie').forEach((btn) => {
		btn.addEventListener('click', function (e) {
			e.preventDefault();
			const src = btn.getAttribute('data-src');
			lockScroll();
			movieContent.innerHTML = `
			<video id="modalMovieVideo" controls width="800" src="${src}"></video>`;
			movieModal.showModal();
			movieModal.scrollTop = 0;

			// モーダル開いたら再生
			setTimeout(() => {
				const videoEl = document.getElementById('modalMovieVideo');
				if (videoEl) videoEl.play();
			}, 50); // showModal直後はDOM未描画のため
		});
	});

	// 閉じる時
	function closeMovieModal() {
		// 再生停止
		const videoEl = document.getElementById('modalMovieVideo');
		if (videoEl) {
			videoEl.pause();
			videoEl.currentTime = 0; // 先頭に戻す
		}
		movieModal.close();
		unlockScroll();
	}
	movieCloseBtn.addEventListener('click', closeMovieModal);

	movieModal.querySelectorAll('.modal-close').forEach((btn) => {
		btn.addEventListener('click', closeMovieModal);
	});

	// top message slider

	const sliderWrapper = document.getElementById('js-slider');
	const slider = document.querySelector('.slider');
	const nextBtn = document.getElementById('nextBtn');
	const modalMessage = document.getElementById('modalMessage');

	let resizeTimer;

	// リサイズ時はtransitionを無効化
	window.addEventListener('resize', () => {
		sliderWrapper.style.transition = 'none';

		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(() => {
			sliderWrapper.style.transition = '';
			// fixedでない時のみ高さ調整
			if (!slider.classList.contains('is-fixed')) {
				adjustSliderHeight();
			}
		}, 100);
	});

	nextBtn.addEventListener('click', (e) => {
		e.preventDefault();
		// sliderをfixedに変更
		slider.classList.add('is-fixed');
		// modalMessageのスクロール位置をリセット
		if (modalMessage) {
			modalMessage.scrollTop = 0;
		}
		// スライドを表示
		sliderWrapper.classList.add('active');
		lockScroll();
	});

	document.querySelectorAll('.prevBtn').forEach((btn) => {
		btn.addEventListener('click', function (e) {
			e.preventDefault();
			// fixedを解除
			slider.classList.remove('is-fixed');
			sliderWrapper.classList.remove('active');
			// modalMessageのスクロール位置をリセット（戻る時も）
			if (modalMessage) {
				modalMessage.scrollTop = 0;
			}

			unlockScroll();
		});
	});

	function adjustSliderHeight() {
		const inners = document.querySelectorAll('.slider__inner');
		if (window.innerWidth <= 768) {
			sliderWrapper.style.height = '';
			return;
		}
		let maxHeight = 0;
		inners.forEach((inner) => {
			if (inner.classList.contains('slider__inner--second')) {
				return;
			}
			const prev = inner.style.display;
			inner.style.display = 'block';
			const h = inner.offsetHeight;
			if (h > maxHeight) maxHeight = h;
			inner.style.display = prev;
		});
		sliderWrapper.style.height = `${maxHeight}px`;
	}

	window.addEventListener('DOMContentLoaded', adjustSliderHeight);
	window.addEventListener('resize', adjustSliderHeight);

	function fadeImages() {
		//contents fade
		const fadetargets = document.querySelectorAll('.js-fade');
		const options = {
			root: null,
			rootMargin: '0px 0px',
			threshold: 0,
		};

		var perfEntries = performance.getEntriesByType('navigation');
		var type = null;
		perfEntries.forEach(function (pe) {
			// 読み込みタイプを取得
			type = pe.type;
		});

		let observer = new IntersectionObserver(callback, options);
		fadetargets.forEach((fadetarget) => {
			observer.observe(fadetarget);
		});

		function callback(entries) {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add('active');
					observer.unobserve(entry.target);
				}
			});
		}
	}
	window.addEventListener('DOMContentLoaded', fadeImages);
});
